import { List, ListItem, LoadingShimmer } from '@icarros/ids-react';

import { IconWrapper } from '../style';
import { ReactComponent as PlateIcon } from '../../../../assets/rebranding/veiculos/placa.svg';
import React from 'react';
import { ResumePlateWrapper } from './style';
import { formatPlate } from '../../../utils/formatters';
import { useAdContext } from '../../../store/contexts/ad';
import { useWebappFlags } from '../../../hooks/useWebAppFlags';

export function VehiclePlate(): JSX.Element {
  const { currentAd } = useAdContext();
  const { getFlagOnSession } = useWebappFlags();

  const { placa } = currentAd.veiculo;

  return (
    <ResumePlateWrapper>
      <List>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            hasLine={getFlagOnSession('validacaoChassi') ?? false}
            avatarIconElement={
              <IconWrapper>
                <PlateIcon />
              </IconWrapper>
            }
            avatarVariant="icon"
            label="placa"
            subLabel="ocultada no anúncio"
            descript={formatPlate(placa)}
            variant="simple"
          />
        </LoadingShimmer>
      </List>
    </ResumePlateWrapper>
  );
}
